// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1N7gL","right":"Footer_right__rOChk","buttons":"Footer_buttons__2j2rO"};